export default "__VITE_ASSET__BPQgxMJ___"